import { Spacer } from '@spritz-finance/ui'
import React, { useState } from 'react'
import styled from 'styled-components'
import { useScreenSize } from '../../../context/useScreenSize'
import { AccountCard } from './accounts/AccountCard'
import { RemoveAccountDialog } from './accounts/RemoveAccountDialog'
import { RenameAccountDialog } from './accounts/RenameAccountDialog'
import { BankAccount } from './BankAccounts'

type AccountsListProps = { accounts: BankAccount[] }

const ListContainer = styled.div`
    padding-bottom: 72px;
`
export const AccountsList = ({ accounts }: AccountsListProps) => {
    const { isDesktop } = useScreenSize()
    const [accountToRemove, setAccountToRemove] = useState<BankAccount | null>(null)
    const [accountToRename, setAccountToRename] = useState<BankAccount | null>(null)

    return (
        <>
            <ListContainer>
                {accounts.map((account) => (
                    <React.Fragment key={account.id}>
                        <AccountCard
                            account={account}
                            onRemoveAccount={(account) => setAccountToRemove(account)}
                            onRenameAccount={(account) => setAccountToRename(account)}
                        />
                        {isDesktop ? <Spacer height={32} /> : <Spacer height={16} />}
                    </React.Fragment>
                ))}
            </ListContainer>
            <RenameAccountDialog
                account={accountToRename}
                onClose={() => setAccountToRename(null)}
            />
            <RemoveAccountDialog
                account={accountToRemove}
                onClose={() => setAccountToRemove(null)}
            />
        </>
    )
}
